import { computed, inject } from '@angular/core';
import { signalStore, withComputed } from '@ngrx/signals';

import { PendingRequestsApiService } from '../requests/api/pending-requests-api.service';
import type { PendingRow } from '../requests/api/requests.models';
import { freshSource, withPagedSources } from '../requests/request-paging';
import { isAbsenceRow, isExchangeRow } from '../requests/request-rows.helper';

type SourceKey = 'exchange' | 'pendingAbsence' | 'openEndedAbsence';

const SOURCE_KEYS: SourceKey[] = ['exchange', 'pendingAbsence', 'openEndedAbsence'];

const identifyRow = (row: PendingRow) => row.id;

export const RequestsPanelStore = signalStore(
  withPagedSources<SourceKey, PendingRow>({
    keys: SOURCE_KEYS,
    buildState: () => ({
      exchange: freshSource(),
      pendingAbsence: freshSource(),
      openEndedAbsence: freshSource(),
    }),
    buildResources: () => {
      const api = inject(PendingRequestsApiService);

      return {
        // Every list is grouped and counted per department, which only holds with every row
        // loaded, so this panel never pages.
        paginationEnabled: false,
        fetchers: {
          exchange: (page) => api.listPendingExchanges(page),
          pendingAbsence: (page) => api.listPendingAbsences(page),
          openEndedAbsence: (page) => api.listApprovedOpenEndedAbsences(page),
        },
      };
    },
    identifyRow,
  }),
  withComputed(({ sources }) => ({
    exchangeRows: computed(() => sources()['exchange'].rows.filter(isExchangeRow)),
    pendingAbsenceRows: computed(() => sources()['pendingAbsence'].rows.filter(isAbsenceRow)),
    openEndedAbsenceRows: computed(() => sources()['openEndedAbsence'].rows.filter(isAbsenceRow)),
  })),
);
